import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import "../css/content-page.scss";
import "../css/policies.scss";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function PolicyDocument({ policy }) {
  const titleId = `${policy.slug}-title`;

  return (
    <main className={`content-page policy-page policy-page--${policy.slug}`}>
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath={policy.path} />

        <article className="content-page__article" aria-labelledby={titleId}>
          <header className="content-page__header">
            <p className="content-page__eyebrow">{policy.eyebrow}</p>
            <h1 id={titleId}>{policy.title}</h1>
            <p className="content-page__lead">{policy.lead}</p>
          </header>

          <p className="content-page__meta">Last updated: October 16, 2026</p>

          {policy.notice && (
            <div className="content-page__notice" role="note">
              <strong>{policy.notice.title}</strong> {policy.notice.text}
            </div>
          )}

          {policy.callout && (
            <section className="content-page__callout">
              <h2>{policy.callout.title}</h2>
              <p>{policy.callout.text}</p>
            </section>
          )}

          {policy.sections.map((section, index) => (
            <section className="content-page__section" key={section.title}>
              <h2>{index + 1}. {section.title}</h2>
              {section.paragraphs?.map((paragraph, paragraphIndex) => (
                <p key={`${section.title}-paragraph-${paragraphIndex}`}>
                  {paragraph}
                </p>
              ))}
              {section.items && (
                <ul className="content-page__list">
                  {section.items.map((item, itemIndex) => (
                    <li key={`${section.title}-item-${itemIndex}`}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}

          {policy.related?.length > 0 && (
            <section className="content-page__section" aria-labelledby={`${policy.slug}-related`}>
              <h2 id={`${policy.slug}-related`}>Related policies</h2>
              <div className="policy-page__related">
                {policy.related.map((link) => (
                  <Link
                    className="content-page__inline-link"
                    key={link.to}
                    to={link.to}
                    onClick={scrollToTop}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </section>
          )}

          <aside className="content-page__support" aria-label={`${policy.title} support`}>
            <div>
              <h2>{policy.supportTitle || "Questions about this policy?"}</h2>
              <p>Email harv@sickzuno.online and include any relevant order reference.</p>
            </div>
            <a
              className="content-page__inline-link"
              href={`mailto:harv@sickzuno.online?subject=${encodeURIComponent(policy.title)}`}
            >
              Email sickzuno
            </a>
          </aside>
        </article>
      </div>
    </main>
  );
}

export default PolicyDocument;
